import { DEAL_STATUSES } from 'resources/deal/deal.constants';

export const ACTIVE_DEALS_SEQUENCE = [
  DEAL_STATUSES.ACTIVE,
  DEAL_STATUSES.PRE_LISTING,
  DEAL_STATUSES.HOME_LISTED_COMPLETED,
  DEAL_STATUSES.ACTIVE_LISTING,
];
